<template>
  <div>
    <div class="map-action mb-10" v-if="showMainDiv"> 
      <span class="d-inline-flex position-relative" v-if="showEndTripButton">
        <Button type="secondary" size="mini" @click="openPopUp">
          End Trip
        </Button>
        <div class="popover-custom no-border is-action" placement="topright" v-if="showPopover">
          <div class="popover-body bg-white mr-m5" style="width:350px;">
            <div class="popover-close" @click="closePopUp">
              <svgicon name="icon-close" width="9" height="9" :original="true" />
            </div>
            <div class="popover-header">End Trip</div>
            <p>Are you sure you want to manually end trip ? The Trip cannot be restarted</p>
            <div class="popover-footer">
              <Button type="secondary" size="mini" @click="closePopUp">
                Cancel
              </Button>
              <Button type="primary" size="mini" @click="manualEndTrip">
                End Trip
              </Button>
            </div>
          </div>
        </div>
      </span>
      <span class="d-inline-flex ml-10"
      v-if="showDetailedTrackView">
        <router-link class="link-action d-inline" :to="{ name: 'TrackDetails', query: { id: this.trackTripId }}" target="_blank">
        <svgicon name="icon-track" width="8" height="10" :original="true" /> {{$t('INDENT_DETAILED_TRACK')}}
      </router-link>
      </span>
      <span class="d-inline-flex ml-10">
        <Button type="secondary" size="mini" v-if="showMap && !isLoading && !isOrderLoading" :disabled="isloading || mapLoading"  @click="checkLatestLocation($event)">
          {{$t('REFRESH_LATEST_LOCATION')}}
        </Button>
      </span>
    </div>
      <div v-if="gpsTrackingEnabled">
        <GpsTrack v-if="!isOrderLoading"
          :key="refreshComponent" 
          :order="indent"
          :isOrderLoading="isOrderLoading"
          :isLoading="isLoading"
          :isMapLoading="isMapLoading"
          :showMap="showMap"
          :operator="operator"
          :consentStatus="consentStatus"
          :isShipper="isShipper"
          :mapConfig="mapConfig"
          :environmentVariables="environmentVariables"
          @loadMap="loadMap" />
        <div v-else>{{$t('INDENT_LOADING')}}...</div>
      </div>
      <div v-else-if="yetToTruckIn && !(simTrackingEnabled || appTrackingEnabled)">
        <div>{{$t('INDENT_ENABLE_SIM_TRACK')}}</div>
      </div>
      <div v-else-if="trackingAfterTruckOut  && (((yetToDispatch ||!allGatesTruckedOut) && !premiumSimTrackingEnabled && simTrackingEnabled) || (premiumSimTrackingEnabled && (!indent.flow.sim_tracking.track_trip_id && !indent.flow.gps_tracking.track_trip_id)))">
        <div>{{$t('INDENT_TRACK_AFTER_DISPATCH')}}</div>
      </div>
      <div v-else-if="yetToTruckIn && !premiumSimTrackingEnabled && simTrackingEnabled">
        <div>{{$t('INDENT_TRACK_AFTER_TRUCKIN')}}</div>
      </div>
      <div v-else-if="simTracking">
        <SimTrack v-if="!isOrderLoading"
          :key="refreshComponent"
          :order="indent"
          :isOrderLoading="isOrderLoading"
          :isLoading="isLoading"
          :isMapLoading="isMapLoading"
          :showMap="showMap"
          :operator="operator"
          :consentStatus="consentStatus"
          :isShipper="isShipper"
          :mapConfig="mapConfig"
          :environmentVariables="environmentVariables"
          @getconsent="getconsent" />
        <div v-else>{{$t('INDENT_LOADING')}}...</div>
      </div>
    <div v-else-if="!yetToTruckIn &&!simTrackingEnabled && hasDriverAccepted && hyperTrackingEnabled">
      <div v-if="yetToDispatch">
        <div>{{$t('INDENT_TRACK_AFTER_DISPATCH')}}</div>
      </div>
      <div v-else-if="!yetToDispatch">
        <HyperTrack :order="indent"
          :key="refreshComponent" 
          :hasDriverAccepted="hasDriverAccepted"
          :trackingEnabled="hyperTrackingEnabled"
          @getLocations="getLocations" />
      </div>
    </div>
  </div>
</template>

<script>
import SimTrack from './SimTrack';
import GpsTrack from './GpsTrack';
import HyperTrack from './HyperTrack';
import { LocationTracker } from 'pando-constants';

export default {
  props: {
    indent: {
      type: Object,
      default: () => {},
    },
    gpsTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    isSimTrackingAllowed: {
      type: Boolean,
      default: false,
    },
    simTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    yetToTruckIn: {
      type: Boolean,
      default: false,
    },
    trackingAfterTruckOut: {
      type: Boolean,
      default: false,
    },
    hasDriverAccepted: {
      type: Boolean,
      default: false,
    },
    appTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    hyperTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    isOrderLoading: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isMapLoading: {
      type: Boolean,
      default: false,
    },
    showMap: {
      type: Boolean,
      default: false,
    },
    operator: {
      type: String,
      default: '',
    },
    consentStatus: {
      type: String,
      default: '',
    },
    yetToDispatch:{
      type: Boolean,
      default: false,
    },
    isShipper: {
      type: Boolean,
      default: false,
    },
    premiumSimTrackingEnabled: {
      type: Boolean,
      default: false,
    },
    mapConfig: {
      type: Object,
      default: () => {},
    },
    environmentVariables: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      showPopover: false,
      trackTripId: null,
      hasTripBeenManuallyEnded: false,
      trackTripStatus: null,
      refreshComponent: false,
      loading: false,
    };
  },
  created() {
    this.trackTripId = (this.indent.flow.sim_tracking && this.indent.flow.sim_tracking.track_trip_id) ||
      (this.indent.flow.app_tracking && this.indent.flow.app_tracking.track_trip_id) ||
      (this.indent.flow.gps_tracking && this.indent.flow.gps_tracking.track_trip_id);
    this.hasTripBeenManuallyEnded = this.indent.flow.trip_ended_by_user;
    this.trackTripStatus = (this.indent.flow.sim_tracking && this.indent.flow.sim_tracking.trip_status) ||
      (this.indent.flow.app_tracking && this.indent.flow.app_tracking.trip_status) ||
      (this.indent.flow.gps_tracking && this.indent.flow.gps_tracking.trip_status);
      
  },
  components: {
    SimTrack,
    GpsTrack,
    HyperTrack,
  },
  methods: {
    getconsent(phone, tripId) {
      this.$emit('getconsent', phone, tripId);
    },
    loadMap(tripId) {
      this.$emit('loadMap', tripId);
    },
    checkLatestLocation(event){
      event.preventDefault();
      this.refreshComponent = !this.refreshComponent;
    },
    getLocations(orderNo) {
      this.$emit('getLocations', orderNo);
    },
    manualEndTrip() {
      this.$emit('manualEndTrip');
      this.hasTripBeenManuallyEnded=true;
      this.closePopUp();
    },
    closePopUp() {
      this.showPopover=false;
    },
    openPopUp() {
      this.showPopover=true;
    },
  },
  computed: {
    simTracking(){
      let simTrackingEnabled;
      if (this.yetToTruckIn && this.indent.flow.sim_tracking && this.indent.flow.sim_tracking.track_trip_id &&
     this.premiumSimTrackingEnabled && this.simTrackingEnabled) {
      simTrackingEnabled = true;
      } else if (!this.yetToTruckIn && (this.simTrackingEnabled || this.appTrackingEnabled)) {
        simTrackingEnabled = true;
      } else if (this.trackingAfterTruckOut && !this.yetToDispatch && this.allGatesTruckedOut &&
        (this.simTrackingEnabled || this.appTrackingEnabled)) {
          simTrackingEnabled = true;
      }
      if (this.hyperTrackingEnabled) {
        simTrackingEnabled = false;
      }
      return simTrackingEnabled;
    },
    allGatesTruckedOut(){
      return this.indent.sources.every(source => source.dispatched_at !== null);
    },
    showEndTripButton() {
      return this.$hasPermission('enable_manual_end_trip_button')
      && (!this.trackTripStatus || this.trackTripStatus === LocationTracker.PENDING_TRIP || this.trackTripStatus === LocationTracker.STARTED_TRIP)
      && !this.hasTripBeenManuallyEnded;
    },

    showDetailedTrackView() {
      return this.trackTripId
      && (this.gpsTrackingEnabled
      || (this.isSimTrackingAllowed && this.simTrackingEnabled)
      || (this.appTrackingEnabled && !this.hyperTrackingEnabled)) &&
      this.$hasFeature('detailed_track_view') && this.isShipper
    },
    showMainDiv() {
      return this.showEndTripButton || this.showDetailedTrackView;
    },
  }
};
</script>
